(() => {
  'use strict';
  if (window.BasuriCommerce) { window.BasuriCommerce.init(document); return; }
  const initialized = new WeakSet();
  const find = (root, selector) => [...(root.matches?.(selector) ? [root] : []), ...root.querySelectorAll(selector)];
  const quantityValue = field => Math.max(Number(field.min) || 1, Math.min(Number(field.max) || 99, Math.trunc(Number(field.value) || 1)));
  function syncQuantity(field) {
    field.value = String(quantityValue(field));
    const scope = field.closest('.quantity-control');
    scope?.querySelectorAll('[data-quantity-change]').forEach(button => {
      button.disabled = Number(button.dataset.quantityChange) < 0 ? Number(field.value) <= (Number(field.min) || 1) : Number(field.value) >= (Number(field.max) || 99);
    });
  }
  function initShop(grid) {
    const scope = grid.closest('section') || grid.parentElement;
    const filters = [...scope.querySelectorAll('[data-filter]')];
    const sort = scope.querySelector('[data-sort]');
    const update = () => {
      const active = scope.querySelector('[data-filter].is-active')?.dataset.filter || 'all';
      const cards = [...grid.querySelectorAll('[data-product-card]')];
      cards.forEach(card => { card.hidden = active !== 'all' && card.dataset.category !== active; });
      cards.sort((a, b) => {
        if (sort?.value === 'price-low') return Number(a.dataset.price) - Number(b.dataset.price);
        if (sort?.value === 'price-high') return Number(b.dataset.price) - Number(a.dataset.price);
        if (sort?.value === 'name') return a.dataset.name.localeCompare(b.dataset.name);
        return Number(a.dataset.order) - Number(b.dataset.order);
      }).forEach(card => grid.appendChild(card));
      const status = scope.querySelector('[data-product-count]');
      if (status) status.textContent = `${cards.filter(card => !card.hidden).length} products shown`;
    };
    filters.forEach(button => button.addEventListener('click', () => {
      filters.forEach(item => { item.classList.toggle('is-active', item === button); item.setAttribute('aria-pressed', String(item === button)); });
      update();
    }));
    sort?.addEventListener('change', update);
    update();
  }
  function initGallery(grid) {
    const count = grid.closest('.product-gallery')?.querySelector('[data-gallery-count]');
    const tiles = [...grid.querySelectorAll('.product-media-tile')];
    const update = () => {
      if (!count) return;
      const left = grid.getBoundingClientRect().left;
      let closest = 0, distance = Infinity;
      tiles.forEach((tile, index) => { const next = Math.abs(tile.getBoundingClientRect().left - left); if (next < distance) { distance = next; closest = index; } });
      count.textContent = `${String(closest + 1).padStart(2, '0')} / ${String(tiles.length).padStart(2, '0')}`;
    };
    grid.addEventListener('scroll', update, { passive: true });
    update();
  }
  let galleryImages = [], current = 0, galleryOpener = null;
  function showImage(index) {
    const box = document.querySelector('.product-lightbox');
    if (!box || !galleryImages.length) return;
    current = (index + galleryImages.length) % galleryImages.length;
    const image = box.querySelector('.lightbox-image');
    image.src = galleryImages[current].currentSrc || galleryImages[current].src;
    image.alt = galleryImages[current].alt; image.width = galleryImages[current].naturalWidth || 1200; image.height = galleryImages[current].naturalHeight || 1200;
    box.querySelector('.lightbox-count').textContent = `${String(current + 1).padStart(2, '0')} / ${String(galleryImages.length).padStart(2, '0')}`;
    if (!box.open) { box.showModal(); document.body.classList.add('gallery-is-open'); }
  }
  function openImage(image) {
    galleryImages = [...(image.closest('[data-media-grid]') || document).querySelectorAll('[data-gallery-image]')];
    galleryOpener = image;
    showImage(galleryImages.indexOf(image));
  }
  function initLightbox(box) {
    box.addEventListener('close', () => { document.body.classList.remove('gallery-is-open'); if (galleryOpener?.isConnected) galleryOpener.focus({ preventScroll: true }); });
    box.addEventListener('click', event => { if (event.target === box) box.close(); });
    box.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); showImage(current + (event.key === 'ArrowLeft' ? -1 : 1)); }
    });
  }
  function initAudio(audio) {
    const scope = audio.closest('.tone-section') || document;
    const buttons = [...scope.querySelectorAll('[data-tone-src]')];
    const status = scope.querySelector('#tone-status');
    if (!status || !buttons.length) return;
    let selected = null, request = 0;
    const sync = () => buttons.forEach(button => {
      const playing = button === selected && !audio.paused && !audio.ended;
      button.classList.toggle('is-selected', button === selected);
      button.classList.toggle('is-playing', playing);
      button.setAttribute('aria-pressed', String(playing));
      button.setAttribute('aria-label', `${playing ? 'Pause' : 'Play'} ${button.dataset.toneName}`);
    });
    const error = () => { if (selected) status.textContent = `Couldn’t load ${selected.dataset.toneName}. Select the sound to try again.`; sync(); };
    buttons.forEach(button => button.addEventListener('click', async () => {
      const attempt = ++request;
      if (button === selected && !audio.paused) { audio.pause(); return; }
      document.querySelectorAll('audio').forEach(other => { if (other !== audio) other.pause(); });
      if (button !== selected || audio.error) {
        audio.pause(); selected = button; audio.src = button.dataset.toneSrc;
        audio.setAttribute('aria-label', `${button.dataset.toneName} horn preview`);
      }
      if (audio.ended) audio.currentTime = 0;
      status.textContent = `Loading ${button.dataset.toneName}…`; sync();
      try { await audio.play(); } catch (failure) { if (attempt === request && failure.name !== 'AbortError') error(); }
    }));
    audio.addEventListener('play', sync);
    audio.addEventListener('playing', () => { if (selected) status.textContent = `Playing: ${selected.dataset.toneName}`; sync(); });
    audio.addEventListener('pause', () => { if (selected && !audio.error) status.textContent = `${audio.ended ? 'Finished' : 'Paused'}: ${selected.dataset.toneName}`; sync(); });
    audio.addEventListener('ended', () => { if (selected) status.textContent = `Finished: ${selected.dataset.toneName}`; sync(); });
    audio.addEventListener('error', error);
  }
  function init(root = document) {
    const components = [['[data-product-grid]', initShop], ['[data-media-grid]', initGallery], ['.product-lightbox', initLightbox], ['#horn-audio', initAudio]];
    components.forEach(([selector, initialize]) => find(root, selector).forEach(element => {
      if (initialized.has(element)) return;
      initialized.add(element); initialize(element);
    }));
    find(root, '[data-quantity]').forEach(syncQuantity);
  }
  document.addEventListener('click', event => {
    const image = event.target.closest('[data-gallery-image]');
    if (image) openImage(image);
    const button = event.target.closest('button');
    if (button?.matches('.lightbox-close')) document.querySelector('.product-lightbox')?.close();
    if (button?.matches('.lightbox-prev,.lightbox-next')) showImage(current + (button.matches('.lightbox-prev') ? -1 : 1));
    if (button?.matches('[data-quantity-change]')) {
      const field = button.closest('.quantity-control')?.querySelector('[data-quantity]');
      if (field) { field.value = String(quantityValue(field) + Number(button.dataset.quantityChange)); syncQuantity(field); }
    }
  });
  document.addEventListener('keydown', event => {
    if ((event.key === 'Enter' || event.key === ' ') && event.target.matches('[data-gallery-image]')) { event.preventDefault(); openImage(event.target); }
  });
  document.addEventListener('change', event => { if (event.target.matches('[data-quantity]')) syncQuantity(event.target); });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('audio').forEach(audio => audio.pause());
    const box = document.querySelector('.product-lightbox');
    if (box?.open && (event.target.contains(galleryOpener) || event.target.contains(box))) box.close();
    if (event.target.contains(galleryOpener)) { galleryImages = []; galleryOpener = null; }
    if (event.target.querySelector('.product-lightbox')) document.body.classList.remove('gallery-is-open');
  });
  window.addEventListener('pagehide', () => document.querySelectorAll('audio').forEach(audio => audio.pause()));
  window.BasuriCommerce = { init };
  init();
})();
